import { render, staticRenderFns } from "./addByFhd.vue?vue&type=template&id=a789dada&scoped=true"
import script from "./addByFhd.vue?vue&type=script&lang=js"
export * from "./addByFhd.vue?vue&type=script&lang=js"
import style0 from "./addByFhd.vue?vue&type=style&index=0&id=a789dada&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a789dada",
  null
  
)

export default component.exports